import {
  OVERRIDES,
  PLANNED,
  ROUTES,
  SAME_DAY,
  SECTIONS,
  SHIFT_MANAGERS,
  LOCATIONS,
  WAVES,
  DRIVERS_PROFILES,
  DRIVERS_SCHEDULES,
} from "./sentryIds";

export const mapTabs = [
  { dataTestId: "outers-tab", label: "Outers", sentryId: "OUTERS--CARDS" },
  { dataTestId: "sectors-tab", label: "Sectors", sentryId: "SECTORS--CARDS" },
  {
    dataTestId: "postcodes-tab",
    label: "Postcodes",
    sentryId: "POSTCODES--CARDS",
  },
];

export const defaultTabs = [
  { dataTestId: "sections-tab", label: "Sections", sentryId: SECTIONS },
  { dataTestId: "routes-tab", label: "Routes", sentryId: ROUTES },
  { dataTestId: "waves-tab", label: "Waves", sentryId: WAVES },
];

export const locationTabs = [
  { dataTestId: "sections-tab", label: "Sections", sentryId: SECTIONS },
  { dataTestId: "routes-tab", label: "Routes", sentryId: ROUTES },
  { dataTestId: "locations-tab", label: "Locations", sentryId: LOCATIONS },
];

export const collectionTabs = [
  { dataTestId: "planned-tab", label: "Planned", sentryId: PLANNED },
  { dataTestId: "same-day-tab", label: "Same Day", sentryId: SAME_DAY },
];

export const overrideTabs = [
  { dataTestId: "overrides-tab", label: "Overrides", sentryId: OVERRIDES },
];

export const driverTabs = [
  {
    dataTestId: "driver-profiles-tab",
    label: "Profiles",
    sentryId: DRIVERS_PROFILES,
  },
  {
    dataTestId: "driver-schedules-tab",
    label: "Work Schedules",
    sentryId: DRIVERS_SCHEDULES,
  },
];

export const routeTabs = [
  { dataTestId: "routes-tab", label: "Routes", sentryId: ROUTES },
];

export const sectionTabs = [
  { dataTestId: "sections-tab", label: "Sections", sentryId: SECTIONS },
];

export const shiftManagerTabs = [
  {
    dataTestId: "shift-manager-tab",
    label: "Shift Managers",
    sentryId: SHIFT_MANAGERS,
  },
];
